import React, { Component } from 'react';
// import logo from './logo.svg';
import './App.css';
import Header from './components/header';
import { Switch,Route} from 'react-router-dom';
// import  FurnitureDeatils from './components/furnituredetail';
// import Furniture from './components/furniture';
// import Successpage from './components/successpage';
// import Chat from './components/chat';
// import "../node_modules/lightgallery.js/dist/css/lightgallery.css";
import Home from './pages/home';
import Footer from './components/footer';
import Transfers from './pages/transfers';
import Contactus from './pages/contactus';
import Aboutus from './pages/about';
import Partneruniversitiessouthcarolina from './pages/partner-universities-south-carolina';
import Partneruniversitiessuny from './pages/partner-universities-suny';
import Presidentsbio from './pages/presidentsbio';
import OrganizationStructure from './pages/organizationstructure';
import LiveClassroomTechnology from './pages/liveclassroomtechnology';
import CoreTeam from './pages/coreteam';
import Ourlocation from './pages/ourlocation';
import Academics from './pages/academics';
import Admissions from './pages/admissions';
import StudentsServices from './pages/studentservices';
import TechnologyPartner from './pages/technologypartner';
import Transfers_to_suny from './pages/transfers-to-suny';
import Aspirezone from './pages/aspirezone';
import Aspireacademy from './pages/aspireacademy';
import Partneruniversities from './pages/partner-universities';
import Partneruniversitiesarkansas from './pages/partner-universities-arkansas';
import MastersInternational from './pages/mastersinternational';
import MastersScience from './pages/mastersscience';
import Aspirecampus from './pages/aspirecampus';
import CoreTeamDetail from './pages/coreteamdetail';
import Transfering_to_non_suny from './pages/transfering_to_non_suny';
import Transfering_to_a_university_with_campus_in_qatar from './pages/transfering_to_university_with_a_campus_in_qatar';
class App extends Component {
  render() {
  return (
    <React.Fragment>
      
       <Switch>
         <Route path="/aboutus" component = {Aboutus} />
         <Route path="/academics" component = {Academics} />
         <Route path="/admissions" component = {Admissions} />
         <Route path="/aspireacademy" component = {Aspireacademy} />
         <Route path="/aspirecampus" component = {Aspirecampus} />
         <Route path="/aspirezone" component = {Aspirezone} />
         <Route path="/contactus" component = {Contactus} />
         <Route path="/coreteam/:slug" component = {CoreTeamDetail} />
         <Route path="/liveclassroomtechnology" component = {LiveClassroomTechnology} />
         <Route path="/masters_international" component = {MastersInternational} />
         <Route path="/masters_in_science" component = {MastersScience} />
         <Route path="/location" component = {Ourlocation} />
         <Route path="/students_services" component = {StudentsServices} />
         <Route path="/technology_partner" component = {TechnologyPartner} />
         <Route path="/transfers" component = {Transfers} />
         <Route path="/transfers_to_suny" component = {Transfers_to_suny} />
         <Route path="/transfering_to_non_suny_system_university" component = {Transfering_to_non_suny} />
         <Route path="/transfers_to_a_university_with_a_campus_in_qatar" component = {Transfering_to_a_university_with_campus_in_qatar} />
         <Route path="/partner_universities" component = {Partneruniversities} />
         <Route path="/partner_university_arkansas" component = {Partneruniversitiesarkansas} />
         <Route path="/partner_university_south_carolina" component = {Partneruniversitiessouthcarolina} />
         <Route path="/partner_university_suny" component = {Partneruniversitiessuny} />
         <Route path="/presidentsbio" component = {Presidentsbio} />
         <Route path="/organization_structure" component = {OrganizationStructure} />
         <Route path="/coreteam" component = {CoreTeam} />
         
         <Route path="/" component ={Home} />
         
       </Switch>
       <Footer></Footer>
    </React.Fragment>
  );
  }
}

export default App;
